import { createSelector } from 'reselect';

const masterData = (state) => state.masters.masterData;
const paginationData = (state) => state.masters.paginationData;
const isDataLoading = (state) => state.masters.isLoading;
const validateMasterData = (state) => state.masters.validateMasterData;
const isError = (state) => state.masters.isError;
const errorMessage = (state) => state.masters.errorMessage;

export const getIsError = createSelector([isError], (data) => data);
export const getErrorMessage = createSelector([errorMessage], (data) => data);

export const getTableMasterData = createSelector([masterData], (data) => data);
export const getPaginationMasterData = createSelector([paginationData], (data) => data);
export const getIsMasterDataLoading = createSelector(
  [isDataLoading],
  (data) => data
);
export const getValidateMasterData = createSelector(
  [validateMasterData],
  (data) => data
);
const addedData = (state) => state.masters.addedData;
const showAddedData = (state) => state.masters.showAddedData;

const currAdvSearchFormType = (state) => state.masters.advSearchFormType;
const isAdvSearchOngoing = (state) => state.masters.isAdvSearchOngoing;
const cardsData = (state) => state.masters.cardsData;
const isCardDataLoading = (state) => state.masters.isCardDataLoading;
const isCardDataError = (state) => state.masters.isCardDataError;

export const getCardsData = createSelector([cardsData], (data) => data);
export const getIsCardDataLoading = createSelector(
  [isCardDataLoading],
  (data) => data
);
export const getIsCardDataError = createSelector(
  [isCardDataError],
  (data) => data
);

export const getShowAddedData = createSelector([showAddedData], (data) => data);
export const getAddedData = createSelector([addedData], (data) => data);

export const getCurrAdvSearchFormType = createSelector(
  [currAdvSearchFormType],
  (data) => data
);
export const getIsAdvSearchOngoing = createSelector(
  [isAdvSearchOngoing],
  (data) => data
);
/**
export const getAllMasterData = createSelector([allMasterData], (data) => {
  let locationCards,
    bankCards,
    userCards,
    trainingCards,
    schemeCards,
    otherCards = [];

  if ('locationMasterData' in data) locationCards = data['locationMasterData'];
  if ('bankMasterData' in data) bankCards = data['bankMasterData'];
  if ('userMasterData' in data) userCards = data['userMasterData'];
  if ('trainingMasterData' in data) trainingCards = data['trainingMasterData'];
  if ('schemeMasterData' in data) schemeCards = data['schemeMasterData'];
  if ('otherMasterData' in data) otherCards = data['otherMasterData'];

  return {
    locationCards,
    bankCards,
    userCards,
    trainingCards,
    schemeCards,
    otherCards,
  };
});

export const getIsAllMasterLoading = createSelector(
  [isAllMasterLoading],
  (data) => data
);
 */
